module.exports = __webpack_public_path__ + "media/images/static/interview/ArrowRight-9839efd41f828e4ef7bad88b9f67fa17.png";